import { lazy } from "react";

const Home = lazy(() => import("../../views/Home"))

const AdminDashboard = lazy(() => import("../../views/admin/AdminDashboard"))

const SubscriptionList = lazy(() => import("../../views/admin/subscriptions/SubscriptionList"))
const AddNewSubscription = lazy(() => import("../../views/admin/subscriptions/AddNewSubscription"))
const SubscriptionDetailView = lazy(() => import("../../views/admin/subscriptions/SubscriptionDetailView"))
const BillingFeeCalculator = lazy(() => import("../../views/admin/billing/BillingFeeCalculator"))

const CompanyList = lazy(() => import("../../views/admin/company/CompanyList"))
const CompanyDetailView = lazy(() => import("../../views/admin/company/CompanyDetailView"))
const AdminUserList = lazy(() => import("../../views/admin/users/AdminUserList"))

const UniversalEquipment = lazy(() => import("../../views/admin/universalEquipment/UniversalEquipment"))
const UniversalReadingsDosages = lazy(() => import("../../views/admin/universalTemplates/UniversalReadingsDosages"))
const TesterStripProfiles = lazy(() => import("../../views/admin/testerStripProfiles/TesterStripProfiles"))
const DripDropWorkflowArchitectureDocsPage = lazy(() => import("../../views/admin/documentation/DripDropWorkflowArchitectureDocsPage"))
const FeatureFlags = lazy(() => import("../../views/admin/featureFlags/FeatureFlags"))
const Permissions = lazy(() => import("../../views/admin/permissions/Permissions"))
const Complaints = lazy(() => import("../../views/admin/complaints/Complaints"))
const ProductFeedback = lazy(() => import("../../views/admin/feedback/ProductFeedback"))
const AppErrors = lazy(() => import("../../views/admin/errors/AppErrors"))
const ReachOutMessages = lazy(() => import("../../views/admin/messages/ReachOutMessages"))
const DeactivatedSellers = lazy(() => import("../../views/admin/sellers/DeactivatedSellers"))
const SellerRequests = lazy(() => import("../../views/admin/sellers/SellerRequests"))
const LiveChat = lazy(() => import("../../views/admin/liveChat/LiveChat"))
const PoolProspectLists = lazy(() => import("../../views/admin/poolProspects/PoolProspectLists"))
export const adminRoutes = [
    {
        path: '/admin/dashboard',
        element: <AdminDashboard />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/dashboard/orders',
        element: <Home />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/dashboard/category',
        element: <Home />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/dashboard/seller',
        element: <Home />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/dashboard/payment-request',
        element: <Complaints />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/dashboard/deactive-sellers',
        element: <DeactivatedSellers />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/dashboard/sellers-request',
        element: <SellerRequests />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/dashboard/chat-seller',
        element: <LiveChat />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/subscriptions',
        element: <SubscriptionList />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/subscriptions/addNew',
        element: <AddNewSubscription />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/subscriptions/detail/:subscriptionId',
        element: <SubscriptionDetailView />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/billing-fee-calculator',
        element: <BillingFeeCalculator />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/company',
        element: <CompanyList />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/company/detail/:companyId',
        element: <CompanyDetailView />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/users',
        element: <AdminUserList mode="users" />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/homeowners',
        element: <AdminUserList mode="homeowners" />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/universal-equipment',
        element: <UniversalEquipment />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/universal-readings-dosages',
        element: <UniversalReadingsDosages />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/tester-strip-profiles',
        element: <TesterStripProfiles />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/feature-flags',
        element: <FeatureFlags />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/permissions',
        element: <Permissions />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/product-feedback',
        element: <ProductFeedback />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/errors',
        element: <AppErrors />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/reach-out-messages',
        element: <ReachOutMessages />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/pool-prospect-lists',
        element: <PoolProspectLists />,
        role: 'Admin'
    }
    ,
    {
        path: '/admin/documentation',
        element: <DripDropWorkflowArchitectureDocsPage />,
        role: 'Admin'
    }
]
